// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","background":"App_background__Ff1yf","scrollToTopBtn":"App_scrollToTopBtn__tRFpF","fade2":"App_fade2__xq8IM","fade":"App_fade__HAPxP"};